<template>
    <div id="personal_intru">
        <div class="close-btn">
            <button @click="close"><v-img src="@/assets/img/closeButton2.svg"></v-img></button>
        </div>
        <div class="content-wrap">
            <div class="title"><p>하늘의 고리와 눈을 마주치다</p></div>
            <div class="content">

채널헤드를 찾는 동안 딱 두 번의 비가 내렸다. 연구자들과 같이 일기예보를 보며 참 곤란하다는 이야기를 주고받았던 기록이 있다. 그때 나는 비가 오는 날 우산 들어주는 기계 역할을 하러 콜드슬립에 찾아가기로 했는데, 그만 깜빡 잊어버리고 만다. 
<br>
<br>
현장에 도착했을 때 연구자 3과 채널헤드는 비바람 속에서 우산 하나를 나눠 쓰고 있었다. 그들의 눈앞에서 불투명한 하얀 우산이 곡선을 따라 굴러갔다. 두 명의 인간은 비바람이 지나는 길목에 서서 축축해지고 있는 상태였다. 
<br>
<br>
“강북구 지역의 일기예보를 챙겨봐 줘요. 적어도 채널헤드들을 초대한 주간에는!”
<br>
<br>
“미안합니다.”
<br>
<br>
“나도 연구자 2의 꿈이 물에 홀딱 젖는다면 글자가 서로 엉겨 붙을 때까지 구해주지 않을 거야.”
<br>
<br>
“굳이?”
<br>
<br>
“두 번 사과할 때까지는요.”
<br>
<br>
“미안해.”
<br>
<br>
비바람이 몰아치는 <span class="sound_text_visited" :class="{'sound-text' : visited[15] === 'disabled'}" @click="play('악몽')">악몽</span>의 공격은 시각 청각 촉각 모두를 구사한다. 그 앞에 드러나면 몸을 숨기기 어렵다. 늦었지만 대책을 다시 강구했다. 소리는 비가 오는 날이면 더 크게 들린다. 그럴 때는 우리가 소리에게 가지 말고, 소리가 우리를 찾아오게 해도 무방할 것 같았다. 나가지 않고 얌전히 연구실에 머물렀다는 뜻이다. 그날의 채널헤드들은 연구실 근거리 좌표에 대해 증언했다. 
<br>
<br>
<br>
<br>

비가 오면 세상은 더욱 그럴듯해진다. 사는 일이 누군가 배경을 꾸려가고 있는 샌드박스라면, 가끔 이 게임의 플레이어는 골드가 부족해서 세상을 어쩔 수 없는 상태로 두는 것이구나. 생각할 때가 있다. 그래서 이렇게 시시하고 엉망인 세계를 굴리는 거구나. 하지만 비가 오는 날이면 세상은 잠시 특별해진다. 비어있는 시야와 청각을 내내 적시는 물방울. 아주 짧은 스페셜 이펙트의 순간이다. 조금 더 자주 샤워하지 그래…. 전할 곳이 없는 충고를 생각하며 정경을 본다.
<br>
<br>
소리는 고체, 액체, 기체의 순서대로 빠르게 전달된다. 소리가 전달되려면 매질이라는 매개가 있어야 하는데, 건조한 날씨에는 공기를 매질로 사용하고 비오는 날에는 빗물과 습기를 매질로 사용한다. 기초소리학시간에 그런 얘기가 나왔다. “그럼 비가 올 때 실기시험을 본 사람들은 조금 더 유리했겠네요?” 선생님은 그래서 실기 시험 날은 여지없이 강수량이 0퍼센트로 예보된 날을 고른다고 말해줬다. 그러나 음향원은 기본적으로 습했다. 고도가 높고 땅이 차가워 자주 <span class="sound_text_visited" :class="{'sound-text' : visited[16] === 'disabled'}" @click="play('안개')">안개</span>가 꼈다.
<br>
<br>
수업을 듣고 나서 첫 번째로 비가 온 날에 이리에와 교정으로 산책을 나왔다. 각자 우산을 하나씩 들고, 질퍽한 운동장 모래를 피해서 보도블록을 밟았다. 
<br>
<br>
“고체, 액체, 기체가 다 갖춰진 드문 환경이다. 오늘 음향 완전히 락페스티벌.”
<br>
<br>
내가 우산 손잡이를 살짝 흔들며 말했다. 우산은 고체, 바깥은 액체, 우산 안쪽은 다시 기체. 김이리에가 나를 앞질러 구령대 계단을 두 개씩 올랐다. 따라 오르려고 했더니 손바닥으로 만류하는 시늉을 했다.
<br>
<br>
“거기 있어봐. 어. 뒤로 더 멀리 가. 내가 뭐라고 하는지 맞춰 봐.” 
<br>
<br>
그가 한쪽 손으로 입을 가리고 문장 하나를 말했다. 너무 크지 않게, 너무 작지도 않게. 
<br>
<br>
“하늘의 고래와 눈을 마주치다?”
<br>
<br>
채점을 기다리듯이 증언하자 김이리에는 활짝 웃었다. <span class="sound_text_visited" :class="{'sound-text' : visited[17] === 'disabled'}" @click="play('표정')">달라진 표정이 빗줄기 속에서도 선명했다.</span>
<br>
<br>
“맞아. 너도 이제 고래네.”
<br>
<br>
그리고는 다시 계단을 내려왔다. 이리에는 자비로운 시험 감독관이었다. 비오는 날 테스트를 진행해주고. 
<br>
<br>
“비밀 하나 알려줄까.”
<br>
<br>
“응.”
<br>
<br>
“고래가 아니라, 고리였다? 그러니까, 하늘의 고래와 눈을 마주치는 게 아니라. 하늘의 고리와 눈을 마주치다였어.” 
<br>
<br>
김이리에가 입학시험의 비화를 들려주었다. 하늘의 고리는 하늘의 고래보다 더 이상하다. 불신의 기색을 감추지 못하고 찡그렸다.
<br>
<br>
“하늘의 고리가 뭐야?”
<br>
<br>
“나도 몰라.” 
<br>
<br>
“하늘에 고리가 왜 있어.”
<br>
<br>
“그럼 과녁 뚫는 메아리는 뭔데? 여기 입시 원래 그래. 일부만 들어서 문장 짜 맞출 수 없게.”
<br>
<br>
“사람들은 왜 고래로 알고 있지?”
<br>
<br>
“나한테 안 물어봤으니까.”
<br>
<br>
“나도 마찬가지잖아.”
<br>
<br>
“그냥. 널 고래로도 만들고, 비밀도 만들고.”
<br>
<br>
<br>
<br>

조금 더 가까이 살면 좋겠다.<br>
지금도 가까워. 같은 층이고.<br>
바로 옆이나 위처럼 말이야. 그러면 좋을 것 같아.<br>
그럼 존나 시끄럽게 할 건데?<br>
그건 안 돼. 넌 303호와도 이웃이 될 거거든.<br>
<br>
<br>
살다보면 이런 순간이 있다. 걔가 날려 보낸 마음을 나는 줍지 못하고 주변을 빙빙 돈다. 마치 못 본 것처럼 마음을 뺀 나머지에 대해서 재빨리 묘사한다. 이리에는 웃었다. 그는 땅에 떨어진 걸 회수하지 않는다. 산책로 트랙을 도는 것처럼 내 옆에서 빙 둘러 따라 걸었다. 
<br>
<br>
좋겠어. 그렇다면 좋겠어. 네가 옆방으로 옮겼으면 좋겠다고 말해줬을 때, 벽을 사이에 두고 맞닿은 침대 위에서 서로가 잠들었을까 궁금해할 수 있다면. 종이컵 전화기를 만들어 두 개의 문 너머를 타고서도 전달되는 단어가 있다는 걸 깨달을 수 있다면. 
<br>
<br>
미워하지 않는다는 건 사랑할 수 있다는 뜻은 되지 못한다. 어떤 점에서는 그것이 더 이리에를 불행하게 만들지도 모르겠다.
<br>
<br>
미워하면서도 그를 사랑할 수 있는 사람들과,<br>
미워하지 않지만 사랑하지는 않는 사람.<br>
<br>
<br>
사랑에 빠지게 만드는 방법을 알아챈 사람들끼리 사랑할 수 있다면 좋을걸. 사랑을 행하는 걸 빈 공간을 찰랑찰랑 채워줄 수 있는 방법이나, 마음을 낫게 만들 수 있는 방법이라고 부를 수 있다면. 가장 먼저 빈자리를 알아챈 사람이 책임지고 해결할 수 있도록 설계된 영혼과 육체라면 좋을걸. 나는 실행이 어려운 청사진을 발견한 사람처럼 그 옆을 서성거린다. 모르는 척할까, 하지만 이것이 다시는 발견되지 못하면 어떡하지. 귀띔을 해줄 수는 없을까. 팔 수 없어, 교환할 수도 없어, 나는 그것을 다시 자리에 두고 나뭇가지를 세운다. 
<br>
<br>
여기.<br>
부디 이곳을 파헤치세요. <span class="sound_text_visited" :class="{'sound-text' : visited[18] === 'disabled'}" @click="play('행운')">행운을 빕니다.</span>
<br>
<br>

그런 날이면 세상 전체가 실패한 발굴자들의 서성거림처럼 느껴진다. 
<br>
<br>

            </div>
        </div>
    </div>
</template>
<script>
import eventBus from '@/plugins/eventbus.js'
import store from "@/store/index.js";

export default {
  name: 'index_eight',
   data() {
    return {
        visited : {
            15: store.getters['getMusicIconUsable'](15),
            16: store.getters['getMusicIconUsable'](16), 
            17: store.getters['getMusicIconUsable'](17),
            18: store.getters['getMusicIconUsable'](18),
        },
        
    }
  },
  methods: {
    close() {
        this.$emit("btnclose");
    },
    play(message) {

        switch(message) {
            case '악몽' :      
                store.commit("toggleText", 15)
                eventBus.$emit("iconUsable", 15); 
                this.visited[15] = 'active';
                break; 
            case "안개" :
                store.commit("toggleText", 16)
                eventBus.$emit("iconUsable", 16); 
                this.visited[16] = 'active';
                break;
            case "표정" :
                store.commit("toggleText", 17)
                eventBus.$emit("iconUsable", 17); 
                this.visited[17] = 'active';
                break;
            case "행운" :
                store.commit("toggleText", 18)
                eventBus.$emit("iconUsable", 18); 
                this.visited[18] = 'active';
                break;
        }
    }
  }
}
</script>

<style scoped>
::-webkit-scrollbar {
display: none;
}

#personal_intru {
  box-sizing: border-box;

  position: absolute;
  height: 649px;
  width: 500px;

  border-radius: 20px;
  border: 1px solid rgba(0, 0, 0, 0.6);

  background: rgba(26, 26, 26, 0.9);
  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(40px);
  /* Note: backdrop-filter has minimal browser support */

  border-radius: 20px;

  left: 906px;
  top: 200px;

  text-align: center;
}

.close-btn {
    position: relative;
    height: 16px;
    width: 16px;
    left: 16px;
    top: 16px;
    border-radius: 16px;
}

.content-wrap {
    position : relative;

    left: 60px;
    top: 64px;
    height: 569px;
    width: 380px;

    overflow-y: scroll;
}

.title {
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    /* identical to box height */

    text-align: center;

    color: #F1F1F1;

}

.content {
    margin-top: 58px;

    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 200%;
    /* or 36px */

    text-align: justify ;
    color: #F1F1F1;

}

@media (max-width: 600px) {

    #personal_intru {
        top: 500px;
        left: 0;
        width: 100vw;
        height: 600px;
        
    }

    .content-wrap {
        left: 45px;
        width: 310px;
        height: 510px;
    }
    
    .title {
        font-weight: 700;
        font-size: 18px;
        line-height: 22px;
        color: #EAEAEA;


    }

    .content {
        width: 310px;
        height: 510px;
        font-weight: 600;
        font-size: 14px;
        line-height: 200%;
        color: #EAEAEA;

    }
}

</style>